import { List } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { StatusItem } from '../StatusItem';
import { KeyValueItem } from '../KeyValueItem';
import { NewlyCreatedItem } from '../NewlyCreatedItem';
import STRING_KEYS from '../../../../language/keys';
import { HISTORY_ACTION_TYPE } from '../../../../consts/enums';
import { style } from './style';

type HistoryListCollapseProps = {
  data: HistoryValues,
  actionType: string,
  titleEditor: string,
}
export const HistoryListCollapse = ({
  data,
  actionType,
  titleEditor,
}: HistoryListCollapseProps):JSX.Element => {
  const { t: translate } = useTranslation();

  if (typeof data === 'object' && data !== null) {
    const renderItemStatus = (key:string) => {
      return (
        <StatusItem
          status={ key }
        />
      );
    };

    const renderItemNotPrimitive = (key:string, value: HistoryValues)
    :JSX.Element | undefined => {
      if (typeof value === 'object' && value !== null) {
        return (
          <>
            <KeyValueItem
              key={ uuidv4() }
              property={ key }
              value={ null }
            />
            {Object.keys(value).map((item) => {
              return (
                <div
                  key={ uuidv4() }
                  style={ style.list.deepItem }
                >
                  <KeyValueItem
                    property={ item }
                    value={ JSON.stringify(value[item], null, 2) }
                  />
                </div>
              );
            })}
          </>
        );
      }

      return <></>;
    };

    const renderItemPrimitive = (key:string, value: HistoryValues):JSX.Element | undefined => {
      if (key === 'status') {
        return (
          renderItemStatus(value)
        );
      }

      return (
        <KeyValueItem
          key={ uuidv4() }
          property={ key }
          value={ value }
        />
      );
    };

    return (
      <List sx={ style.list.sx }>
        { actionType ===  HISTORY_ACTION_TYPE.CREATE &&  (
          <NewlyCreatedItem
            text={ translate(STRING_KEYS.THIS_ENTITY, { entity: titleEditor }) }
          />
        )}
        {Object.keys(data).map((item: string) => {
          return (
            <div key={ uuidv4() }>
              <div style={ style.list.item }>
                {!Array.isArray(item) && !(typeof data[item] === 'object') &&
                 renderItemPrimitive(item, `${data[item]}`)}
                {!Array.isArray(item) && !(typeof item === 'object') ?
                  renderItemNotPrimitive(item, data[item]) :
                  renderItemPrimitive(item, data[item])}
              </div>
            </div>
          );
        })}
      </List>
    );
  }

  return <div>{translate(STRING_KEYS.EMPTY)}</div>;
};
